import React, { FormEvent } from "react";
import "./Footer.css";
import logo from "../../Assets/logo.png";
import paymentIcon from "../../Assets/paymentIcon.png";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
// import { FaYoutube, FaPinterest } from "react-icons/fa"; // Commented out for now

import { Link } from "react-router-dom";
import { Autocomplete, TextField } from "@mui/material";
import QrCodeModal from "../Model/QrModel";

const Footer: React.FC = () => {
  const handleSubscribe = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    alert("Subscribed Successfully");
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };



  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer_left">
          <h5 style={{color:'#5e626b'}}>About Us</h5>
          <p style={{ textAlign: "justify",color:'#5e626b' }}>
            Established/ Founded in 2015 as PLANET ENTERPRISES and had been
            involved with FMCG. Especially Indian Devotional items. We started
            with manufacturing / Trading the 100% Natural and traditional
            materials. Founded in 2020, GANGA SUPERMARKET - Grocery Store
            (Offline & Online Store) and started the Ganga Supermarket second
            outlet at Namakkal (Offline Store) in 2022.
          </p>

          <div className="social_links">
            <FaFacebookF />
            <FaInstagram />
          </div>
        </div>

        <div className="footer_content">
          <h5 style={{color:'#5e626b'}} >Contact Us</h5>
          <div className="links_container">
            <p style={{color:'#5e626b'}}>
              Warehouse: 4/426 HA Ganga Nagar, Thuraiyur Road, Namakkal-637002
              Outlet: 3/824-A, Near Ponni gas Godown, Thuraiyur Road,
              Namakkal-637002
            </p>
            <p style={{color:'#5e626b'}}>91-9043426746</p>
            <p style={{color:'#5e626b'}}>customer.care@gangasupermarket.com</p>
          </div>
        </div>

        <div className="footer_content">
          <h5 style={{color:'#5e626b'}}>Testimonials</h5>
          <div className="links_container">
            <a
              href="https://www.google.com/maps/place/Ganga+Supermarket/@11.2174002,78.1875669,17z/data=!3m1!4b1!4m6!3m5!1s0x3babcff9d135a941:0x3a78f8d6521748a3!8m2!3d11.2174002!4d78.1875669!16s%2Fg%2F11pkj95dkj?entry=ttu&g_ep=EgoyMDI1MDMzMS4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
            >
              Reviews in Google Business Profile
            </a>
            <div style={{marginTop:'10px'}}>
            <QrCodeModal/>

            </div>
          </div>
        </div>

        <div className="footer_right">
          <h5 style={{color:'#5e626b'}}>Newsletter Signup</h5>
          <p style={{color:'#5e626b'}}>
            Sign up to Our Newsletter & get attractive Offers by subscribing to
            our newsletters.
          </p>

          <form onSubmit={handleSubscribe}>
            <input type="email" placeholder="Your email address" required />
            <button type="submit">Join</button>
          </form>

          <h6 style={{color:'#5e626b'}}>Secure Payments</h6>
          <div className="paymentIconContainer">
            <img src={paymentIcon} alt="Secure Payments" />
          </div>
        </div>
      </div>

      <div className="footer_bottom">
        <div className="footerLangCurrency">
          <div className="footerLang">
            <Link
              to="/about"
              className="links_container"
              style={{ textDecoration: "none", color: "#5e626b" }}
            >
              <p >About Us</p>
            </Link>
          </div>
          <div className="footerLang">
            <Link
              to="/privacypolicy"
              className="links_container"
              style={{ textDecoration: "none",color: "#5e626b" }}
            >
              <p>Privacy Policy</p>
            </Link>
          </div>
          <div className="footerLang">
            <Link
              to="/returnpolicy"
              className="links_container"
              style={{ textDecoration: "none", color: "#5e626b"}}
            >
              <p>Return Policy</p>
            </Link>
          </div>
          <div className="footerLang">
            <Link
              to="/shippingpolicy"
              className="links_container"
              style={{ textDecoration: "none", color: "#5e626b" }}
            >
              <p>Shipping Delivery Policy</p>
            </Link>
          </div>
          <div className="footerLang">
            <Link
              to="/termsandcondition"
              className="links_container"
              style={{ textDecoration: "none", color: "#5e626b" }}
            >
              <p>User Terms and Conditions</p>
            </Link>
          </div>
          <div className="footerLang">
            <Link
              to="/contact"
              className="links_container"
              style={{ textDecoration: "none", color: "#5e626b" }}
            >
              <p>Contact Us</p>
            </Link>
          </div>
          <div className="footerLang">
            <p>Site Map</p>
          </div>
          <div className="footerLang">
            <Link
              to="/loginSignUp"
              className="links_container"
              style={{ textDecoration: "none", color: "#5e626b" }}
            >
              <p>Login</p>
            </Link>
          </div>

          <div className="footerLang">
          
          </div>

          <div className="footerLang" style={{color:'#5e626b'}}>
            Our Products Never Lie 
            Ganga Supermarket © 2025
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
